import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ClientStorageService } from '@app/core/services/client-storage.service';
import { Store } from '@ngxs/store';
import { UserContextSelectors } from '@app/shared/state/user-context/user-context.selectors';
import { POST_LOGIN_REDIRECT_URL_KEY } from '../config/auth-redirect.config';

export const authGuardFn: CanActivateFn = async (_, state) => {
  const router = inject(Router)
  const clientStorageService = inject(ClientStorageService)
  const store = inject(Store)

  const isAuthenticated = store.selectSnapshot(UserContextSelectors.isAuthenticated)

  if (!isAuthenticated) {
    clientStorageService.setItem(POST_LOGIN_REDIRECT_URL_KEY, state.url)
  }

  return isAuthenticated || router.createUrlTree(['/login'])
};
